import { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { SecondaryPriceType, SecondaryQuotationType } from 'state/secondaryMarket/productSearch';
import type { RealtimeQuoteBcsProduct } from 'state/secondaryMarket/referential/bcsProduct/bcsProduct.model';
import type { Collection } from 'state/utils/types';

export type AstroProductStatus = 'Active' | 'NotActive' | 'Missing';

export type AstroProductLoadingStatus = 'Error' | 'Loading';

type AstroProductCustodian = { bdrId: string; bdrName: string; notional: number };

export type AstroProductClient = { id: string; name: string; custodians: AstroProductCustodian[] };

export type AstroProduct = Readonly<{
  clients: AstroProductClient[];
  isActive: boolean;
  productId: string;
  productIdSource: string;
  productIdType: string;
  isin?: string;
  fileCode?: string;
  name?: string;
  denomination?: number;
  currency?: string;
  maturityDate?: string;
  priceType?: SecondaryPriceType;
  priceDefinition: Uppercase<SecondaryQuotationType>;
  valuationInformations: {
    url: string;
  };
}>;
export type AstroProductBasedOnBcsProduct = Omit<RealtimeQuoteBcsProduct, 'error'> &
  Pick<AstroProduct, 'isActive' | 'productId' | 'productIdSource' | 'productIdType'> & {
    clients: ISalesCounterpart[];
    lifecycleUrl: string;
  };
export type AstroProductState = Readonly<{
  hasError: boolean;
  isLoading: boolean;
  data: AstroProductBasedOnBcsProduct | null;
}>;

export type AstroProductMap = Collection<AstroProductState>;

export const initialAstroProductMap = {};

export function mapAstroProductClientsToISalesCounterpart(clients?: AstroProductClient[]): ISalesCounterpart[] {
  return clients?.map(p => ({ id: p.id, label: p.name })) ?? [];
}
